import Gallery, {DIRECTION_FORWARDS} from "webPage/Gallery";
import GlobalEvents from "base/GlobalEvents";

export default function handleHeroElements($elements) {
    $elements.each(function () {
        handleHeroElement($(this));
    });
}

function handleHeroElement($element) {
    let gallery = new Gallery($element, {
        itemClass: "hero__slide", pipClass: "hero__pip", itemsClass: "js-hero-slides", animationDuration: 800,
    });

    let hasInteracted = false;
    let timeout = galleryTimeout();

    gallery.$gallery.addClass('has-loaded');
    gallerySetToSlideHeight(gallery, 0, false);
    gallerySetActionsStyle(gallery, 0);

    gallery.on('transitionStart', ({from, to}) => {
        gallerySetToSlideHeight(gallery, to);
        gallerySetActionsStyle(gallery, to);
    });

    gallery.on('navigate', () => {
        clearTimeout(timeout);
        hasInteracted = true;
    });

    gallery.on('goTo', () => {
        clearTimeout(timeout);
        hasInteracted = true;
    });

    function galleryTimeout() {
        let isFirst = gallery.getActiveIndex() === 1;

        return setTimeout(() => {
            gallery.navigate(DIRECTION_FORWARDS);

            setTimeout(() => {
                timeout = galleryTimeout();
            });
        }, (4 + (isFirst ? 8 : 0)) * 1000);
    }

    $(window).on('resize', () => {
        if ($(window).outerWidth() >= 1024) {
            gallery.$gallery.find('.js-hero-slides').css({'height': ''});
        }

        let index = gallery.getActiveIndex();
        gallerySetToSlideHeight(gallery, index, false);
    });

    $(window).on('scroll', () => {
        let offset = gallery.$gallery.outerHeight();

        if ($(window).scrollTop() >= offset) {
            clearTimeout(timeout);
            timeout = null;
        } else if (timeout === null && !hasInteracted) {
            timeout = galleryTimeout();
        }
    });

    GlobalEvents.on('navigation.open', () => {
        clearTimeout(timeout);
        timeout = null;
    }).on('navigation.close', () => {
        if (hasInteracted) {
            return;
        }
        timeout = galleryTimeout();
    });
}

function gallerySetToSlideHeight(gallery, index, animate = true) {
    if ($(window).outerWidth() >= 1024) {
        return;
    }

    let new_height = gallery.getItem(index).innerHeight();

    if (animate) {
        gallery.$gallery.find('.js-hero-slides').stop().animate({
            height: new_height,
        }, {
            duration: 400,
        });
    } else {
        gallery.$gallery.find('.js-hero-slides').stop().css({'height': new_height});
    }
}

function gallerySetActionsStyle(gallery, index) {
    let item  = gallery.getItem(index);
    if($(item[0]).is('.hero__slide--mach-2024')) {
        gallery.$gallery.addClass('hero--dark-bg');
    } else {
        gallery.$gallery.removeClass('hero--dark-bg');
    }
}